<div class="review-interview-wrapper" *ngIf="current else loading">
    <replay-responses [currentAttempt]='current' (getQuestion)="currentQuestion($event)">
        <div class="attempts-select-div" *ngIf="!_dataService.practice && attempts && attempts.length > 0">
            <select class="attempts" name="attempts" [ngModel]="current.video_interview_attempt_id" (ngModelChange)="playCurrentAttempt($event)">
                <option *ngFor="let att of attempts; let i=index" [ngValue]="att.video_interview_attempt_id">
                    {{'interviews.Attempt' | translate}} #{{i+1}} — {{att.created_tz}}
                </option>
            </select>
        </div>
        <menu-button class="menu-button" [items]="menuItems" (itemSelected)="onMenuItemSelected($event)"></menu-button>
        <div class="overall-feedback" *ngIf="!_dataService.practice && question?.feedback.length && question.average_rating">
            <h2 class="title reviewer-title"> {{'interviews.Average Rating' | translate}}</h2>
            <div>
                <stars-rating [rating]="question.average_rating"></stars-rating>
                <div class="text-center">{{'interviews.Based on {reviews_count} reviews' | translate: {reviews_count: question.feedback.length} }}</div>
            </div>
        </div>
        <div class="feedback-section" *ngIf="!_dataService.practice && attempts?.length">
            <div class="feedback-header">
                <h2 class="title">{{'interviews.Feedback' | translate}}</h2>
                <button class="btn" *ngIf="current.enable_student_feedback != 0 && _dataService.hasAvailableReviewerTypes" (click)="openRequestFeedbackModal();">
                    {{'interviews.Request Feedback' | translate}}
                </button>
            </div>
            <feedback-list *ngIf="question?.feedback.length || _dataService.aiFeedbackRequested" [feedbackList]="question?.feedback || []"></feedback-list>
        </div>
    </replay-responses>
</div>
<ng-template #loading>{{'interviews.Loading...' | translate}}</ng-template>
